export const getLogoUrlForOrganisation = (organisationName: string): string => {
  switch (organisationName) {
    case 'Bellhop':
      return 'http://cdn.mcauto-images-production.sendgrid.net/42b1640a6bc21fc4/33bf4112-7b16-4c7d-9517-2f444e6edcaa/800x250.png';
    case 'SteadyMD':
      return 'http://cdn.mcauto-images-production.sendgrid.net/42b1640a6bc21fc4/5e91391e-581b-41e4-a590-012ca9678661/1214x256.png';
    case 'AptDeco':
      return 'http://cdn.mcauto-images-production.sendgrid.net/42b1640a6bc21fc4/9a492708-c3ca-473d-936e-8b6bd1b06ad7/721x160.png';
    case 'KHealth':
      return 'http://cdn.mcauto-images-production.sendgrid.net/42b1640a6bc21fc4/2fe3a203-3218-4e35-b940-15fa41a6d859/227x80.png';
    default:
      // Arya's logo
      return 'http://cdn.mcauto-images-production.sendgrid.net/42b1640a6bc21fc4/c57013ed-c9f6-4513-9f02-e90246887acf/562x234.png';
  }
};
